import { MAX_I16 } from '@sg/shared/src/util/numbers'
import { maxValue, minValue, nullable, number, optional, pipe, type InferOutput } from 'valibot'

export const ArmyPaintIdSchema = pipe(number(), minValue(1), maxValue(MAX_I16))

export const OptionalNullableArmyPaintIdSchema = optional(nullable(ArmyPaintIdSchema))

export type ArmyPaintId = InferOutput<typeof ArmyPaintIdSchema>
